import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicMenu({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M2.43 4.93h11.14c.24 0 .43-.2.43-.43V3.43c0-.24-.2-.43-.43-.43H2.43c-.24 0-.43.2-.43.43V4.5c0 .24.2.43.43.43zm0 4.28h11.14c.24 0 .43-.19.43-.42V7.7c0-.23-.2-.42-.43-.42H2.43c-.24 0-.43.19-.43.42v1.1c0 .23.2.42.43.42zm0 4.29h11.14c.24 0 .43-.2.43-.43V12c0-.24-.2-.43-.43-.43H2.43c-.24 0-.43.2-.43.43v1.07c0 .24.2.43.43.43z" />
    </svg>
  );
}

SvgBasicMenu.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicMenu.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicMenu svgRef={ref} {...props} />);
export default ForwardRef;
